import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { StorageService } from '../../services/storage/storage.service';
import { AuthService } from 'src/app/feature-module/auth/services/auth.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  loaderActive = false;
  endPointUrl: string;
  anonymousUrls = [
    'token',
    'signup',
    'role/actives',
    'sendResetPasswordOTP',
    'passwordReset',
    'fileValidator',
    'GCSubmission/findClaim',
    'GCSubmission/validateClaimAndGenerateOTP',
    'GCSubmission/OTPValidationForAdditionalDocumentSubmission',
    'GCSubmission/getNigoDocumnetByClaimEntryId',
    'GCSubmission/getClaimInformation',
    'GCSubmission/additionalDocumentSubmission',
    'GCSubmission/add',
    'GCSubmission/document',
    'GCSubmission/otp',
    'GCSubmission/claimreport',
    'GCSubmission/claimFormDocument',
    'enums/getIndClaimSubmitterRole',
    'individual-claim-submission/otp-validation-individual',
    'individual-claim-submission/authenticate-claim-submitter',
    'individual-claim-submission/validate-policy-data',
    'individual-claim-submission/required-documents',
    'individual-claim-submission/document-based-on-incident',
    'individual-claim-submission/add',
    'individual-claim-submission/validateIndividualClaim',
	  'individual-claim-submission/getDocumentsAndPatientName',
    'otp/otpSessionCancel',
    'eb-dashboard-auth/generate-otp',
    'eb-dashboard-auth/validate-otp',
    'api/eb-dashboard/v2/landing-page-details',
    'api/eb-dashboard/v2/claim-history-details',
    'api/eb-dashboard/v2/all-active-members',
    'claim-status-details',
    'api/eb-email-generation/send-members-benefits-email',
    'api/eb-email-generation/send-life-card-email',
    'api/eb-email-generation/send-claim-usage-email',
    'api/eb-email-generation/send-payment-explanation-email',
    'api/eb-email-generation/send-medical-card-email',
    'api/eb-dashboard/v2/has-claim-usage-and-life-card'
  ];
  constructor(
    private spinner: NgxSpinnerService,
    private storageService: StorageService,
    private authService: AuthService
  ) {
    this.endPointUrl = environment.endPointUrl;
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.loaderActive) {
      setTimeout(() => {
        this.spinner.show();
        this.loaderActive = true;
      });
    }

    if (
      !(
        request.url.includes('group-doc.json') ||
        request.url.includes('individual-doc.json') ||
        request.url.includes('product-map.json')
      )
    ) {
      request = request.clone({
        url: this.endPointUrl + request.url,
      });

      const token = this.storageService.getItem('access_token');

      if (!token && !this.anonymousUrls.find((x) => request.url.includes(x))) {
        this.authService.signoutLocally();
      }

      if (token && !this.anonymousUrls.find((x) => request.url.includes(x))) {
        const type_token: string = this.storageService.getItem('token_type');
        const tokenValue : string = this.storageService.getItem('access_token');

        request = request.clone({
          headers: request.headers.set('Authorization', type_token + ' ' + tokenValue),
        });
      }
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.loaderActive = true;
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.authService.signoutLocally();
        }
        return throwError(error);
      }),
      finalize(() => {
        setTimeout(() => {
          this.spinner.hide();
          this.loaderActive = false;
        });
      })
    );
  }
}
